/**
 * @generated SignedSource<<243a1d1b3ab983e9384b9f5156986e0a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProgramCalendarWeek_week$data = {
  readonly description: string | null | undefined;
  readonly id: string;
  readonly week: number;
  readonly " $fragmentType": "ProgramCalendarWeek_week";
};
export type ProgramCalendarWeek_week$key = {
  readonly " $data"?: ProgramCalendarWeek_week$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProgramCalendarWeek_week">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProgramCalendarWeek_week",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "week",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    }
  ],
  "type": "Week",
  "abstractKey": null
};

(node as any).hash = "4294419a84ccaf93930a8e33556efa16";

export default node;
